// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.jogo-card {
  background: white;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  padding: 16px;
  margin-bottom: 12px;
  transition: all 0.3s ease;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}

.jogo-card:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  border-color: #2196f3;
}

.jogo-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
  padding-bottom: 8px;
  border-bottom: 1px solid #f0f0f0;
}

.jogo-data {
  font-size: 12px;
  color: #666;
  font-weight: 500;
}

.jogo-hora {
  font-size: 14px;
  color: #333;
  font-weight: 600;
}

.jogo-confronto {
  display: flex;
  justify-content: space-around;
  align-items: center;
  margin-bottom: 12px;
  gap: 12px;
}

.selecao {
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 1 1;
  text-align: center;
}

.selecao .bandeira {
  margin-bottom: 8px;
  line-height: 1;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 40px;
}

.selecao .bandeira .bandeira-img {
  width: 40px;
  height: auto;
  border-radius: 4px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.selecao .bandeira .bandeira-sigla {
  font-size: 14px;
  font-weight: bold;
  color: #333;
  text-transform: uppercase;
  background: #f0f0f0;
  padding: 4px 8px;
  border-radius: 4px;
}

.selecao .nome {
  font-size: 13px;
  font-weight: 600;
  color: #333;
  line-height: 1.3;
}

.versus {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-width: 50px;
}

.versus .vs {
  font-size: 12px;
  color: #999;
  font-weight: 600;
  text-transform: uppercase;
}

.versus .resultado {
  display: flex;
  align-items: center;
  gap: 4px;
}

.resultado .gols {
  font-size: 20px;
  font-weight: 700;
  color: #2196f3;
  min-width: 24px;
  text-align: center;
}

.resultado .separador {
  font-size: 16px;
  color: #999;
  font-weight: 600;
}

.jogo-info {
  display: flex;
  justify-content: center;
  margin-bottom: 12px;
  padding: 8px 0;
}

.jogo-info .estadio {
  font-size: 12px;
  color: #666;
  background: #f5f5f5;
  padding: 4px 12px;
  border-radius: 4px;
}

.btn-palpitar {
  width: 100%;
  padding: 10px 16px;
  background: linear-gradient(135deg, #2196f3 0%, #1976d2 100%);
  color: white;
  border: none;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
}

.btn-palpitar:hover {
  background: linear-gradient(135deg, #1976d2 0%, #1565c0 100%);
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(33, 150, 243, 0.3);
}

.btn-palpitar:active {
  transform: translateY(0);
}

.badge-resultado,
.badge-em-andamento {
  width: 100%;
  padding: 8px 12px;
  text-align: center;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
}

.badge-resultado {
  background: #e8f5e9;
  color: #2e7d32;
}

.badge-em-andamento {
  background: #fff3e0;
  color: #e65100;
}

@media (max-width: 600px) {
  .jogo-card {
    padding: 12px;
  }

  .selecao .bandeira {
    font-size: 24px;
  }

  .selecao .nome {
    font-size: 12px;
  }

  .resultado .gols {
    font-size: 18px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/componentes/JogoCard.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,yCAAyC;AAC3C;;AAEA;EACE,yCAAyC;EACzC,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,6BAA6B;EAC7B,mBAAmB;EACnB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAO;EACP,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,wCAAwC;AAC1C;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,WAAW;EACX,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,6DAA6D;EAC7D,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,6DAA6D;EAC7D,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;;EAEE,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":[".jogo-card {\n  background: white;\n  border: 1px solid #e0e0e0;\n  border-radius: 8px;\n  padding: 16px;\n  margin-bottom: 12px;\n  transition: all 0.3s ease;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);\n}\n\n.jogo-card:hover {\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\n  border-color: #2196f3;\n}\n\n.jogo-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 12px;\n  padding-bottom: 8px;\n  border-bottom: 1px solid #f0f0f0;\n}\n\n.jogo-data {\n  font-size: 12px;\n  color: #666;\n  font-weight: 500;\n}\n\n.jogo-hora {\n  font-size: 14px;\n  color: #333;\n  font-weight: 600;\n}\n\n.jogo-confronto {\n  display: flex;\n  justify-content: space-around;\n  align-items: center;\n  margin-bottom: 12px;\n  gap: 12px;\n}\n\n.selecao {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  flex: 1;\n  text-align: center;\n}\n\n.selecao .bandeira {\n  margin-bottom: 8px;\n  line-height: 1;\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  min-height: 40px;\n}\n\n.selecao .bandeira .bandeira-img {\n  width: 40px;\n  height: auto;\n  border-radius: 4px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n.selecao .bandeira .bandeira-sigla {\n  font-size: 14px;\n  font-weight: bold;\n  color: #333;\n  text-transform: uppercase;\n  background: #f0f0f0;\n  padding: 4px 8px;\n  border-radius: 4px;\n}\n\n.selecao .nome {\n  font-size: 13px;\n  font-weight: 600;\n  color: #333;\n  line-height: 1.3;\n}\n\n.versus {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  min-width: 50px;\n}\n\n.versus .vs {\n  font-size: 12px;\n  color: #999;\n  font-weight: 600;\n  text-transform: uppercase;\n}\n\n.versus .resultado {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n}\n\n.resultado .gols {\n  font-size: 20px;\n  font-weight: 700;\n  color: #2196f3;\n  min-width: 24px;\n  text-align: center;\n}\n\n.resultado .separador {\n  font-size: 16px;\n  color: #999;\n  font-weight: 600;\n}\n\n.jogo-info {\n  display: flex;\n  justify-content: center;\n  margin-bottom: 12px;\n  padding: 8px 0;\n}\n\n.jogo-info .estadio {\n  font-size: 12px;\n  color: #666;\n  background: #f5f5f5;\n  padding: 4px 12px;\n  border-radius: 4px;\n}\n\n.btn-palpitar {\n  width: 100%;\n  padding: 10px 16px;\n  background: linear-gradient(135deg, #2196f3 0%, #1976d2 100%);\n  color: white;\n  border: none;\n  border-radius: 6px;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n}\n\n.btn-palpitar:hover {\n  background: linear-gradient(135deg, #1976d2 0%, #1565c0 100%);\n  transform: translateY(-2px);\n  box-shadow: 0 4px 12px rgba(33, 150, 243, 0.3);\n}\n\n.btn-palpitar:active {\n  transform: translateY(0);\n}\n\n.badge-resultado,\n.badge-em-andamento {\n  width: 100%;\n  padding: 8px 12px;\n  text-align: center;\n  border-radius: 4px;\n  font-size: 12px;\n  font-weight: 600;\n  text-transform: uppercase;\n}\n\n.badge-resultado {\n  background: #e8f5e9;\n  color: #2e7d32;\n}\n\n.badge-em-andamento {\n  background: #fff3e0;\n  color: #e65100;\n}\n\n@media (max-width: 600px) {\n  .jogo-card {\n    padding: 12px;\n  }\n\n  .selecao .bandeira {\n    font-size: 24px;\n  }\n\n  .selecao .nome {\n    font-size: 12px;\n  }\n\n  .resultado .gols {\n    font-size: 18px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
